var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"bi bi-square-fill",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }